import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./Profile.scss";

import avatarFallback from "../../assets/images/avatar/avatar20.webp";

import {
  logout,
  getBalance,
  getPlayersUnderMyAgent,
} from "../../redux/actions/session";

import Menu from "../../components/menuDesktop/MenuDesktop";
import MobileMenu from "../../components/menuMobile/MenuMobile";
import { hapticLight, isHapticEnabled, setHapticEnabled } from "../../utils/haptic";
import { SUPPORT } from "../../utils/constants";

const Profile = () => {
  const token = useSelector((state) => state.session.token);
  const cellphone = useSelector((state) => state.session.cellphone);
  const nickname = useSelector((state) => state.session.nickname);
  const score = useSelector((state) => state.session.score);
  const role = useSelector((state) => state.session.role);
  const dispatch = useDispatch();

  const shouldUpdate = useRef(true);
  const [hapticOn, setHapticOn] = useState(isHapticEnabled());

  const toggleHaptic = () => {
    const next = !hapticOn;
    setHapticEnabled(next);
    setHapticOn(next);
    if (next) hapticLight();
  };

  useEffect(() => {
    if (shouldUpdate.current) {
      shouldUpdate.current = false;
      dispatch(getBalance());
      if (role === "agent") {
        dispatch(getPlayersUnderMyAgent());
      }
    }
  });

  if (!token) return null;

  return (
    <div className="profile-page">
      <Menu />

      {/* TITLE */}
      <section className="profile-page__title">
        <h1>Perfil</h1>
        <p>Gerencie sua conta e preferências</p>
      </section>

      {/* PROFILE CARD */}
      <section className="profile-page__card profile-card">
        <div className="profile-card__banner" />

        <div className="profile-card__avatar">
          <img src={avatarFallback} alt="" />
        </div>

        <div className="profile-card__actions">
          <a
            href={SUPPORT.whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="profile-card__action"
          >
            <i className="fa-brands fa-whatsapp" /> Suporte
          </a>
          {score != null && (
            <span className="profile-card__action profile-card__action--solid">
              Pontos: {score}
            </span>
          )}
        </div>

        {nickname && (
          <div className="profile-card__identity">
            <h2>{nickname}</h2>
          </div>
        )}
      </section>

      {/* INFO CARD */}
      <section className="profile-page__card profile-info">
        <h3 className="profile-info__title">Informações</h3>
        <p className="profile-info__hint">
          Essas informações não podem ser editadas, qualquer dúvida fale com o
          nosso time pelo whatsapp.
        </p>

        {nickname && (
          <div className="profile-info__field">
            <label>Nome de usuário</label>
            <input type="text" value={nickname} readOnly />
          </div>
        )}

        {cellphone && (
          <div className="profile-info__field">
            <label>Celular</label>
            <input type="text" value={cellphone} readOnly />
          </div>
        )}
      </section>

      {/* PREFERENCIAS */}
      <section className="profile-page__links">
        <button
          type="button"
          className="profile-link profile-link--toggle"
          onClick={toggleHaptic}
          aria-pressed={hapticOn}
        >
          <span className="profile-link__icon">
            <i className="fa-solid fa-mobile-screen-button" />
          </span>
          <span className="profile-link__label">Vibração (resposta háptica)</span>
          <span
            className={`profile-toggle ${hapticOn ? "profile-toggle--on" : ""}`}
            aria-hidden="true"
          >
            <span className="profile-toggle__dot" />
          </span>
        </button>
      </section>

      {/* LINKS */}
      <section className="profile-page__links">
        <a
          href="/politica-de-privacidade.html"
          target="_blank"
          rel="noopener noreferrer"
          className="profile-link"
        >
          <span className="profile-link__icon">
            <i className="fa-regular fa-file-lines" />
          </span>
          <span className="profile-link__label">Política de privacidade</span>
          <span className="profile-link__chev">
            <i className="fa-solid fa-chevron-right" />
          </span>
        </a>

        <a
          href="/termos-e-condicoes.html"
          target="_blank"
          rel="noopener noreferrer"
          className="profile-link"
        >
          <span className="profile-link__icon">
            <i className="fa-regular fa-file-lines" />
          </span>
          <span className="profile-link__label">Termos de uso</span>
          <span className="profile-link__chev">
            <i className="fa-solid fa-chevron-right" />
          </span>
        </a>
      </section>

      {/* LOGOUT */}
      <button
        type="button"
        className="profile-page__logout"
        onClick={() => dispatch(logout())}
      >
        Encerrar sessão
      </button>

      {/* FOOTER */}
      <footer className="profile-page__footer">
        <span className="profile-page__footer-brand">trucoxp©</span>
        <span>{new Date().getFullYear()}</span>
        <span className="profile-page__footer-sep">•</span>
        <span>
          <a
            href="/termos-e-condicoes.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Termos de Uso
          </a>
          {" | "}
          <a
            href="/politica-de-privacidade.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Política de Privacidade
          </a>
        </span>
      </footer>

      <MobileMenu />
    </div>
  );
};

export default Profile;
